import React, { useState, useEffect } from "react";
import UserAvatar from "../../../../components/user/UserAvatar";
import { DropdownToggle, DropdownMenu, Dropdown } from "reactstrap";
import { Icon } from "../../../../components/Component";
import { LinkList, LinkItem } from "../../../../components/links/Links";
import { api, setAuthToken } from "../../../../utils/api";
import { useHistory } from "react-router-dom";

const User = () => {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const history = useHistory();
  const toggle = () => setOpen((prevState) => !prevState);

  useEffect(() => {
    const loadUser = async () => {
      try {
        // Toujours récupérer les données à jour depuis l'API
        const userInfo = await api.me();
        setUser(userInfo);
        localStorage.setItem("user", JSON.stringify(userInfo));
      } catch (error) {
        console.error("Error loading user:", error);
        // En cas d'erreur, utiliser les données du localStorage si disponibles
        const userData = localStorage.getItem("user");
        if (userData) {
          setUser(JSON.parse(userData));
        }
      }
    };
    loadUser();
  }, []);

  const handleSignout = async () => {
    try {
      await api.logout();
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setAuthToken(null);
      localStorage.removeItem("user");
      localStorage.removeItem("auth_token");
      history.push(`${process.env.PUBLIC_URL}/auth-login`);
    }
  };

  const getUserInitials = () => {
    if (user?.first_name && user?.last_name) {
      return `${user.first_name[0]}${user.last_name[0]}`.toUpperCase();
    }
    if (user?.email) {
      return user.email[0].toUpperCase();
    }
    return "U";
  };

  const getUserName = () => {
    if (user?.first_name && user?.last_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    return user?.email || "Utilisateur";
  };

  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <UserAvatar
            icon="user-alt"
            size="md"
            text={getUserInitials()}
            theme="blue"
          />
        </div>
      </DropdownToggle>
      <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            <div className="user-avatar">
              <span>{getUserInitials()}</span>
            </div>
            <div className="user-info">
              <span className="lead-text">{getUserName()}</span>
              <span className="sub-text">{user?.email || ""}</span>
            </div>
          </div>
        </div>
        <div className="dropdown-inner">
          <LinkList>
            <LinkItem link="/hse-dashboard" icon="dashlite" onClick={toggle}>
              Tableau de bord
            </LinkItem>
            <LinkItem link="/notifications" icon="bell" onClick={toggle}>
              Notifications
            </LinkItem>
            <LinkItem link="/users/audit" icon="activity-alt" onClick={toggle}>
              Journal d&apos;audit
            </LinkItem>
          </LinkList>
        </div>
        <div className="dropdown-inner">
          <LinkList>
            <a
              href="#signout"
              onClick={(e) => {
                e.preventDefault();
                handleSignout();
              }}
            >
              <Icon name="signout"></Icon>
              <span>Déconnexion</span>
            </a>
          </LinkList>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default User;
